import store from '@store';
import axios from 'axios';

const routes = {
    global: { userGuides: '/api/v1/modules/userGuides' },
    informations: {
        submit: '/api/v1/backoffice/administration/send/25'
    },
    admin: {
        isallowed: '/api/v1/auth/security/isallowed',
        getconfigroles: '/api/v1/auth/security/getconfigroles',
        login: '/api/v1/auth/security/ldap/login',
        logout: '/api/v1/auth/security/ldap/logout',
        anonymous: '/api/v1/auth/security/ldap/anonymous',
        passwordLost: '/api/v1/auth/security/ldap/passwordlost'
    },
    accMgmt: {
        userInfo: '/api/v1/passaccount/info/userInformation',
        userAccessList: '/api/v1/passaccount/info/userAccessList',
        notices: '/api/v1/passaccount/config/notices',
        secretQuestions: '/api/v1/passaccount/config/secretQuestions',
        resetPassAccount: '/api/v1/passaccount/config/reset',
        pwdChange: '/api/v1/passaccount/pwd/change',
        findGeodisLogin: '/api/v1/passaccount/pwd/findGeodisLogin/:UUID',
        sqChange: '/api/v1/passaccount/sq/change',
        sqUser: '/api/v1/passaccount/sq/get',
        sqCheck: '/api/v1/passaccount/sq/check',
        attemptStatus: '/api/v1/passaccount/sq/attempt-status',
        textsWebById: '/api/v1/backoffice/administration/get-textsweb/:id',
        validateUser: '/api/v1/passaccount/info/validateUser/:UUID/:login'
    },
    userMgmt: {
        search: '/api/v1/modules/passLookup/search',
        updateUserAccesses: '/api/v1/modules/passLookup/access/update',
        userAccessList: '/api/v1/modules/userInfos/userAccessList',
        managedServices: '/api/v1/modules/userInfos/managedServices',
        history: '/api/v1/modules/history/userMgmt'
    },
    serviceMgmt: {
        search: '/api/v1/modules/passService/search',
        deleteService: '/api/v1/modules/passService/deleteService',
        createService: '/api/v1/modules/passService/createService',
        updateService: '/api/v1/modules/passService/editService',
        serviceAccessList: '/api/v1/modules/passService/accesses',
        addAccess: '/api/v1/modules/passService/addAccess',
        editAccess: '/api/v1/modules/passService/editAccess',
        deleteAccessList: '/api/v1/modules/passService/deleteAccesses',
        history: '/api/v1/modules/history/accessMgmt',
        listManagers: '/api/v1/modules/passService/listManagers',
        listOwners: '/api/v1/modules/passService/listOwners',
        listGroups: '/api/v1/modules/passService/listGroups',
        serviceManagers: '/api/v1/modules/passService/serviceManagers'
    },
    administration: {
        mails: '/api/v1/backoffice/administration/get-mails',
        ldapConfig: '/api/v1/backoffice/administration/ldapConfiguration',
        updateLdapConfig: '/api/v1/backoffice/administration/ldapConfiguration/update',
        SQList: '/api/v1/backoffice/administration/secretQuestions',
        addSQ: '/api/v1/backoffice/administration/secretQuestions/add',
        deleteSQ: '/api/v1/backoffice/administration/secretQuestions/delete',
        getFrequencies: '/api/v1/backoffice/administration/get-frequencies',
        updateConfigMails: '/api/v1/backoffice/administration/activate-periodic-process',
        activateMailNotifications: '/api/v1/backoffice/administration/activate-mail-notif',
        updateMailList: '/api/v1/backoffice/administration/update-mail-list',
        importGuide: '/api/v1/backoffice/administration/importGuide/:moduleName/:lang',
        deleteGuide: '/api/v1/backoffice/administration/deleteGuide/:moduleName/:lang',
        authorizations: '/api/v1/backoffice/administration/authorizations',
        activatePeriodicProcess: '/api/v1/backoffice/administration/activate-periodic-process',
        textsWeb: '/api/v1/backoffice/administration/get-textsweb',
        updateTextsWeb: '/api/v1/backoffice/administration/update-textsweb',
        getMaxResult: '/api/v1/backoffice/administration/lookup-max-result',
        getBranches: '/api/v1/backoffice/administration/lookup-branches',
        updateLookupConfig: '/api/v1/backoffice/administration/lookup-update',
        getPwdConfig: '/api/v1/backoffice/administration/get-pwd-config',
        updatePwdConfig: '/api/v1/backoffice/administration/update-pwd-config'
    },
    backoffice: {
        import: '/api/v1/backoffice/migrations/import/:dbName',
        cleanDB: '/api/v1/backoffice/migrations/cleanDB/:dbName',
        exportDB: '/api/v1/backoffice/migrations/exportDB/:dbName',
        activatePeriodicProcess: '/api/v1/backoffice/administration/activate-periodic-process',
        textsWeb: '/api/v1/backoffice/administration/get-textsweb',
        updateTextsWeb: '/api/v1/backoffice/administration/update-textsweb',
        getMaxResult: '/api/v1/backoffice/administration/lookup-max-result',
        getBranches: '/api/v1/backoffice/administration/lookup-branches',
        updateLookupConfig: '/api/v1/backoffice/administration/lookup-update'
    }
};

const api = {
    _getServiceName: () => {
        const browserPaths = window.location.pathname
            .split('/')
            .map(path => {
                if (path === '') {
                    return null;
                }
                return path;
            })
            .filter(path => {
                return !!path;
            });
        return browserPaths[0];
    },
    _setParams: (url, params) => {
        for (const query in params) {
            url = url?.replace(`:${query}`, params[query]);
        }
        return url;
    },
    _buildURL: function (route, params, service) {
        let serviceName = service;
        if (!service) {
            serviceName = this._getServiceName();
        }
        if (!serviceName) {
            return null;
        }
        let url = routes[serviceName][route];
        if (params) {
            url = this._setParams(url, params);
        }
        return url;
    },
    get: async function (route, params, options, service) {
        const url = this._buildURL(route, params, service);
        if (!url) {
            store.commit('displayErrors', '11');
            return null;
        }
        const result = await axios.get(`${getOrigin()}${url}`, options).catch(err => {
            store.commit('displayErrors', err.response?.data.errno);
        });
        if (result && (result.data === '' || result.data === false || result.data === null)) {
            return result.data;
        }
        return result?.data || result;
    },
    post: async function (route, body, params, service, headers) {
        const url = this._buildURL(route, params, service);
        const result = await axios
            .post(`${getOrigin()}${url}`, body, { headers, params: params && params.params ? params.params : {} })
            .catch(err => {
                store.commit('displayErrors', err.response.data.errno);
            });
        if (result && (result.data === '' || result.data === false || result.data === null)) {
            return result.data;
        }
        return result?.data || result;
    },
    patch: async function (route, body, params, service) {
        const url = this._buildURL(route, params, service);
        const result = await axios.patch(`${getOrigin()}${url}`, body).catch(err => {
            store.commit('displayErrors', err.response.data.errno);
        });
        if (result && (result.data === '' || result.data === false || result.data === null)) {
            return result.data;
        }
        return result?.data || result;
    },
    setLang: async function (lang, i18n, vuetify) {
        let translations = {};
        try {
            const translationsRes = await axios.get(`/api/v1/backoffice/translations/passAccount/${lang}`);
            translations = translationsRes?.data || {};
        } catch (error) {
            console.log('Loading header translations fail : ', error);
        }
        const fromVuetify = require('../../node_modules/vuetify/lib/locale/' + lang).default;
        const messages = {
            ...translations,
            ...fromVuetify
        };
        const msgMap = {};
        msgMap[lang] = messages;
        vuetify.lang.current = lang;
        vuetify.lang.locales = msgMap;
        i18n.setLocaleMessage(lang, messages);
        i18n.locale = lang;
        return messages;
    }
};

function getOrigin() {
    return window.location.origin;
}

export { api };
